export default __webpack_public_path__ + "static/media/man_stairs.4741ec0b.svg";